import { render, staticRenderFns } from "./testView.vue?vue&type=template&id=6f541242&scoped=true"
import script from "./testView.vue?vue&type=script&lang=js"
export * from "./testView.vue?vue&type=script&lang=js"
import style0 from "./testView.vue?vue&type=style&index=0&id=6f541242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f541242",
  null
  
)

export default component.exports